import axiosHttp from "./interceptor.service";
import axios from "axios";


const getUser = ({ search, sort, limit, page } = {}) => {
  return axiosHttp.get("/feedback/feedback-user", {
    params: { search, sort, limit, page },
  });
};

const getMainUser = ({ search, sort, limit, page } = {}) => {
  return axiosHttp.get("/feedback/main-user", {
    params: { search, sort, limit, page },
  });
}


const updatePassword = (data) => {
  return axios
    .put(`${process.env.REACT_APP_MAIN_URL}/updatePassword`, data)
    .then((res) => {
      const resp = res.data;
      if (res.error) {
        console.log(resp.error);
      } else {
        return resp;
      }
    })
    .catch((err) => {
      return err;
    });
};

const getSpecificUser = (data) => {
  return axiosHttp.get("/feedback/feedback-specificUser", data);
};

const createUser = (data) => {
  return axiosHttp.post("/feedback/feedback-user", data);
};

const updateUser = (id, data) => {
  return axiosHttp.put(`/feedback/feedback-user/${id}`, data);
};

const deleteUser = (id) => {
  return axiosHttp.delete(`/feedback/feedback-user/${id}`);
};

const getUsersByRole = (roleId) => {
  return axiosHttp.get("/feedback/getUsersByRole", {
    params: { roleId }
  });
};

const getHrAdminAccountsUsers = () => {
  return axiosHttp.get("/feedback/getHrAdminAccountsUsers");
};

const getTokenbyData = () => {
  return axiosHttp.get("/lmt/tokenData");
};

const getUserPicker = ({ search, cursor, limit, roles } = {}) => {
  return axiosHttp.get("/feedback/feedback-user-picker", {
    params: { search: search || undefined, cursor: cursor || undefined, limit, roles: roles || undefined },
  });
};

export { getUser, getMainUser, updatePassword, getSpecificUser, createUser, updateUser, deleteUser, getUsersByRole, getHrAdminAccountsUsers, getTokenbyData, getUserPicker };
